import { render, staticRenderFns } from "./orderOverview.vue?vue&type=template&id=07cdf670&scoped=true"
import script from "./orderOverview.vue?vue&type=script&lang=js"
export * from "./orderOverview.vue?vue&type=script&lang=js"
import style0 from "./orderOverview.vue?vue&type=style&index=0&id=07cdf670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cdf670",
  null
  
)

export default component.exports